import semver from 'semver';

import type { FSNode } from '../types/fs-types';
import { normalizePath } from './path';

const normalizeLookupPath = (path: string): string => normalizePath(path).replace(/^\/+/, '').replace(/\/+$/, '');

export const findNodeByPath = (nodes: FSNode[], targetPath: string): FSNode | null => {
    const normalizedTargetPath: string = normalizeLookupPath(targetPath);

    for (const node of nodes) {
        if (normalizeLookupPath(node.path) === normalizedTargetPath) return node;

        if (node.type === 'directory' && node.children) {
            const foundNode: FSNode | null = findNodeByPath(node.children, normalizedTargetPath);
            if (foundNode) return foundNode;
        }
    }

    return null;
};

export const collectFileNodes = (nodes: FSNode[] | undefined | null): FSNode[] => {
    if (!nodes) return [];

    const files: FSNode[] = [];
    for (const node of nodes) {
        if (node.type === 'file') {
            files.push(node);
            continue;
        }

        files.push(...collectFileNodes(node.children));
    }

    return files;
};

export const lvglIs_9_5_0_OrHigher = (version: string): boolean =>
    semver.gte(version.startsWith('v') ? version.slice(1) : version, '9.5.0');
